export default __webpack_public_path__ + "static/P_SearchThumb_IN-7011HD_Downloads-9acf7b971fd2d9e9fe248c4f792867a1.webp";